import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { useBankProfile } from '../contexts/BankProfileContext';
import { useAuth } from './useAuth';

interface MessageSigningPayload {
	topic: string;
	content: {
		text: string;
	};
	attachments?: File[];
	context?: string;
}

const useMessageInitiateSigning = () => {
	const { session } = useAuth();
	const { selectedProfile } = useBankProfile();

	const initiateMessageSigning = async (payload: MessageSigningPayload) => {
		const formData = new FormData();

		formData.append('topic', payload.topic);

		Object.entries(payload.content).forEach(([key, value]) => {
			formData.append(`content[${key}]`, value ?? '');
		});

		if (payload.attachments) {
			payload.attachments.forEach((file, index) => {
				formData.append(`attachments[${index}]`, file);
			});
		}

		if (payload.context) {
			formData.append('context', payload.context);
		}

		const response = await axios.post(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/messages/initiate-signing`,
			formData,
			{
				headers: {
					Authorization: session?.tokenized,
				},
			},
		);

		return response.data;
	};

	return useMutation({
		mutationFn: initiateMessageSigning,
		meta: { suppressGlobalErrors: true },
	});
};

export default useMessageInitiateSigning;
